import imgixConfig from 'Config/imgix';

const backgroundWidths = [5000, 4000, 3200, 2560, 1920, 1600, 1280, 1024, 768, 640];

// Drawn at a fixed 2560px, and full width above that: see $carousel-background-image-width
export const BACKGROUND_SIZES = '(min-width: 2560px) 100vw, 2560px';

/**
 * The srcset and fallback src of the carousel background image, cropped to the advert's 100:26 ratio. Also used by
 * its skeleton (Components/Skeleton/SkeletonCarouselBackground), so both request the same URLs.
 * @param  {String} bgImgSrc Absolute image URL
 * @return {Object} { srcSet, src }
 */
export default function backgroundSources(bgImgSrc) {
  return {
    srcSet: backgroundWidths.map(w => `${bgImgSrc}?${imgixConfig}&w=${w}&h=${Math.round(w * 0.26)}&fit=crop ${w}w`).join(', '),
    src: `${bgImgSrc}?${imgixConfig}&w=1920&h=499&fit=crop`,
  };
}
